"use strict";

require("core-js/modules/es.promise.finally");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var uploadPlaceholder_1 = __importStar(require("../lib/uploadPlaceholder"));

var types_1 = require("../types");

var insertFiles = function insertFiles(view, event, pos, files, options) {
  var images = files.filter(function (file) {
    return /image/i.test(file.type);
  });
  if (images.length === 0) return;
  var dictionary = options.dictionary,
      uploadImage = options.uploadImage,
      onImageUploadStart = options.onImageUploadStart,
      onImageUploadStop = options.onImageUploadStop,
      onShowToast = options.onShowToast;

  if (!uploadImage) {
    console.warn("uploadImage callback must be defined to handle image uploads.");
    return;
  }

  event.preventDefault();
  if (onImageUploadStart) onImageUploadStart();
  var schema = view.state.schema;
  var complete = 0;

  var _iterator = _createForOfIteratorHelper(images),
      _step;

  try {
    var _loop = function _loop() {
      var file = _step.value;
      var id = {};
      var tr = view.state.tr;
      tr.setMeta(uploadPlaceholder_1.default, {
        add: {
          id: id,
          file: file,
          pos: pos
        }
      });
      view.dispatch(tr);
      uploadImage(file).then(function (src) {
        var pos = uploadPlaceholder_1.findPlaceholder(view.state, id);
        if (pos === null) return;
        var transaction = view.state.tr.replaceWith(pos, pos, schema.nodes.image.create({
          src: src
        })).setMeta(uploadPlaceholder_1.default, {
          remove: {
            id: id
          }
        });
        view.dispatch(transaction);
      }).catch(function (error) {
        console.error(error);
        var transaction = view.state.tr.setMeta(uploadPlaceholder_1.default, {
          remove: {
            id: id
          }
        });
        view.dispatch(transaction);

        if (onShowToast) {
          onShowToast(dictionary.imageUploadError, types_1.ToastType.Error);
        }
      }).finally(function () {
        complete++;

        if (complete === images.length) {
          if (onImageUploadStop) onImageUploadStop();
        }
      });
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

exports.default = insertFiles;